import { useHabitatID } from '@akin-home/habitats/react';
import { useListHabitatUsers } from '@akin-home/users/react';

export const useListCurrentHabitatUsers = () => {
  const habitatID = useHabitatID();

  return useListHabitatUsers(habitatID);
};
